<template>
	<div id="app">
		<!-- Modal Sobre -->
		<ModalSobre :visible="showModal" />
		<!-- Navigation-->
		<nav
			class="navbar navbar-expand-lg navbar-dark fixed-top"
      id="mainNav"
      :style="{'--background-color': bgColor, backgroundColor: bgColor}"
		>
			<div class="d-flex">
				<b-button
					v-b-toggle.menuCollapsed
					class="navbar-toggler navbar-toggler-right"
				>
					<span class="navbar-toggler-icon"></span>
				</b-button>
				<span>
					<img
						:src="logo"
						alt="logo"
						id="logo-responsivo"
					/>
				</span>
			</div>

			<b-collapse id="menuCollapsed" class="navbar-collapse o-hidden">
				<img :src="logo" alt="logo" id="logo" />

				<ul class="navbar-nav navbar-sidenav pt-4">
					<li
						class="nav-item"
						data-toggle="tooltip"
						data-placement="right"
						title="Painel"
					>
						<router-link class="nav-link" exact to="/adm_empresa/painel">
							<i class="fa fa-fw fa-dashboard"></i>
							<span class="nav-link-text"> Painel </span>
						</router-link>
					</li>

          <li
						class="nav-item"
						data-toggle="tooltip"
						data-placement="right"
						title="Usuários"
					>
						<router-link class="nav-link" exact to="/adm_empresa/usuarios">
							<i class="fa fa-fw fa-users"></i>
							<span class="nav-link-text"> Usuários </span>
						</router-link>
					</li>

					<li
						class="nav-item"
						data-toggle="tooltip"
						data-placement="right"
						title="Denúncias"
					>
						<router-link class="nav-link" exact to="/adm_empresa/denuncias">
							<i class="fa fa-fw fa-bullhorn"></i>
							<span class="nav-link-text"> Denúncias </span>
						</router-link>
					</li>

					<li
            v-if="hasUnidades"
						class="nav-item"
						data-toggle="tooltip"
						data-placement="right"
						title="Unidades"
					>
						<router-link class="nav-link" exact to="/adm_empresa/unidades">
							<i class="fa fa-fw fa-building"></i>
							<span class="nav-link-text"> Unidades </span>
						</router-link>
					</li>

					<li
						class="nav-item"
						data-toggle="tooltip"
						data-placement="right"
						title="Sobre"
					>
						<button
							class="nav-link bt-open-sobre"
							exact
							to="/adm_prestadora/sobre"
							@click="showModal = !showModal"
						>
							<i class="fa fa-fw fa-info"></i>
							<span class="nav-link-text"> Sobre </span>
						</button>
					</li>
				</ul>

        <ul class="navbar-nav ml-auto">
					<li class="nav-item">
						<a style="color: white;">
              <i class="fa fa-fw fa-user"></i>
							<span v-text="nomeUsuario"></span>
						</a>
					</li>
				</ul>

				<ul class="navbar-nav ml-5">
					<li class="nav-item">
						<a class="nav-link" @click="logOut()">
							<i class="fa fa-fw fa-sign-out"></i>Logout
						</a>
					</li>
				</ul>
			</b-collapse>
		</nav>
		<!-- /Navigation-->

		<!-- Conteudo-->
		<router-view />
		<!-- /Conteudo-->

	</div>
</template>

<script>
import { verificaSeEstaLogado, alerta } from "../../utils/util";
import ModalSobre from "@/components/ModalSobre";
import axios from "axios";
export default {
	components: {
		ModalSobre
	},
	data() {
		return {
			logado: false,
			nomeUsuario: "",
      bgColor: '',
      logo: null,
			showModal: false
		};
	},

  created() {
    var self = this
		var user = verificaSeEstaLogado()
		if (!user) {
			alerta("error", "Usuário não está logado")
			self.$router.replace(this.$route.query.redirect || "/login")
			self.logado = false

		} else {
			if (user.role != 2) {
				window.history.length > 1
					? self.$router.go(-1)
					: self.$router.replace(this.$route.query.redirect || "/login")
          
			} else {
				self.logado = true
				self.nomeUsuario = user.name
			}
		}

		axios.get(`empresas/${user.empresas_id}}`)
      .then(res => {
        self.bgColor = res.data.cor_site_escura
        self.logo = axios.defaults.baseURL.slice(0, -3) + 'arquivos_logo/' + res.data.arquivo_logo
        self.hasUnidades = res.data.unidade_vinculada
      }
    )
  },

	methods: {
		logOut() {
			localStorage.removeItem("token_max")
			this.$router.push("/login")
		}
	}
};
</script>

<style scoped>
@media (min-width: 992px) {
	#mainNav.fixed-top .navbar-sidenav {
		height: calc(100vh);
    background-color: var(--background-color);
	}

	#logo {
		height: 50px;
		display: block !important;
		margin-left: 45px;
	}

	#logo-responsivo {
		display: none;
	}
}

#logo {
	display: none;
}

#logo-responsivo {
	height: 40px;
	margin-left: 5vh;
}

.bt-open-sobre:hover {
	text-decoration: underline;
}
</style>
